module.exports = __webpack_public_path__ + "Roboto-Bold.a9f3ed53688a9f07cb84.svg";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Bold.svg
// module id = ../../../../../src/assets/fonts/Roboto-Bold.svg
// module chunks = main